import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { BradeArrow } from '../../../../Svg';
import { useNavigate } from 'react-router-dom';


function handleClick(event) {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
}

export default function BreadcrumbsForType({ home, type, subType,id }) {
//   console.log('id=========',id);
  
  const navigate = useNavigate()
  
    const breadcrumbs = [
        <Link
            underline="hover"
            key="1"
            color="inherit"
            // href="/"
            onClick={() => navigate('/')}
            sx={{
                fontFamily: 'Public Sans',
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '20px',
                letterSpacing: '0.005em',
                textAlign: 'left',
                color: '#000000',
                paddingRight:'5px',
                cursor:'pointer'
            }}
        >
            {home}
        </Link>,
        <Link
            underline="none"
            key="2"
            color="inherit"
            // href="/material-ui/getting-started/installation/"
            // onClick={goBack}
          
            sx={{
                fontFamily: 'Public Sans',
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '20px',
                letterSpacing: '0.005em',
                textAlign: 'left',
                color: '#000000',
                paddingLeft:'5px',
                cursor:'pointer'
            }}
        >
            {type}
        </Link>,
    ];
    return (
        <Stack >
            <Breadcrumbs separator={<BradeArrow />} aria-label="breadcrumb">
                {breadcrumbs}
            </Breadcrumbs>
        </Stack>
    );
}
